import * as yup from 'yup'

export default yup.object().shape({
  company_id: yup.string().required('O campo Incorporadora é requerido.')
})
